<template>
  <div class="requisition-report-comments-notification-badge">
    <cord-notification-list-launcher
      :filter="JSON.stringify(threadFilter)"
      use-shadow-root="false"
    />
  </div>
</template>

<script>
export default {
  name: 'RequisitionReportCommentsNotificationBadge',

  props: {
    reqUuid: { type: String, default: '' },
  },

  computed: {
    threadFilter() {
      return { location: { page: 'requisition-report', id: this.reqUuid } };
    },
  },
};
</script>

<style scoped lang="less">
@import '@/less/cord';

.requisition-report-comments-notification-badge {
  width: 16px;
  height: 16px;
  overflow: hidden;

  .cord-common-styles();

  :deep(.cord-component-notification-list-launcher) {
    .cord-button.cord-with-icon {
      background-color: transparent;
    }
  }

  .cord-component-notification-list-launcher {
    position: relative;
    right: 8px;
    top: 8px;
    pointer-events: none;
    user-select: none;
  }
}
</style>
